import { useUserDetailContext } from "../../../UserDetailContext";
import { useDispatch } from "react-redux";
import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import ParentComponent from "./ParentComponent";

const PersonalityTest = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const iframeRef = useRef(null);
 console.log("iframeRef", iframeRef)
  const { userDetails } = useUserDetailContext();
  const objectId = localStorage.getItem("objectId");

  const user_full_name =
    userDetails?.firstName + " " + userDetails?.lastName;

  const handleIframeLoad = () => {
    try {
      const currentSrc = iframeRef.current?.src;
      console.log("currentSrc shbchhbsc", currentSrc)
      if (currentSrc?.includes("https://app.neoin.co/jobopening")) {
        navigate("/jobopening");
      }
    } catch (error) {
      console.log("Cannot access iframe URL due to cross-origin", error);
    }
  };

  return (
    <ParentComponent className="d-flex align-items-center justify-content-center">
      <iframe
        ref={iframeRef}
        src={`${process.env.REACT_APP_NEOSCOPE_BASE_URL}?name=${encodeURIComponent(
          user_full_name
        )}&dob=${userDetails?.dob}&accessToken=${encodeURIComponent(objectId)}`}
        title="Neo scope"
        width="90%"
        height="100%"
        style={{ border: "none" }}
        onLoad={handleIframeLoad}
      />
    </ParentComponent>
  );
};

export default PersonalityTest;